// extracted by mini-css-extract-plugin
module.exports = {"crossSiteLabel":"Wj","zenCrossSiteLabel":"Xj","vrsnlCrossSiteLabel":"Yj"};